module.exports = __webpack_public_path__ + "static/media/image_72.05bba565.png";